import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { okaidia } from "react-syntax-highlighter/dist/esm/styles/prism";
import { apiURL } from "../api";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

export default function TaskWithSolutions() {
  okaidia['pre[class*="language-"]'].background = "#212529";

  const [taskData, setTaskData] = useState({});
  const { uuid } = useParams();

  const getTaskWithSolutions = (uuid) => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        method: "task.getTaskWithSolutions",
        params: {
          uuid: uuid,
        },
      }),
    };

    fetch(apiURL + "/public", requestOptions)
      .then((response) => response.json())
      .then((response) => {
        setTaskData(response.result);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getTaskWithSolutions(uuid);
  }, [uuid]);

  return (
    <div>
      <div className="container">
        <div className="row justify-content-between align-items-center my-4">
          <div className="col-auto">
            <HashLink
              to={`/tasks/${taskData.section}#${uuid}`}
              className="btn btn-sm btn-outline-secondary"
            >
              <i className="bi bi-box-arrow-left"> </i>
              До списку задач
            </HashLink>
          </div>

          <div className="col-auto">
            <div className="btn-group btn-group-sm" role="group">
              {taskData.prevTaskUuid && (
                <Link
                  className="btn btn-outline-secondary"
                  style={{ minWidth: "110px" }}
                  to={
                    taskData.prevTaskUuid
                      ? `/tasks/task-with-solutions/${taskData.prevTaskUuid}`
                      : "#"
                  }
                >
                  <i className="bi bi-caret-left"></i>
                  Попередня задача
                </Link>
              )}
              {taskData.nextTaskUuid && (
                <Link
                  className="btn btn-outline-secondary"
                  style={{ minWidth: "110px" }}
                  to={
                    taskData.nextTaskUuid
                      ? `/tasks/task-with-solutions/${taskData.nextTaskUuid}`
                      : "#"
                  }
                >
                  Наступна задача
                  <i className="bi bi-caret-right"></i>
                </Link>
              )}
            </div>
          </div>
        </div>
        <div className="card mt-4 mb-2">
          <div className="card-header">
            <div className="row">
              <div className="col-8 fw-bold">
                {taskData.title || "Завантаження..."}
              </div>
              <div className="col-4 fw-lighter d-flex justify-content-end">
                Складність: {taskData.complexity}
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row fw-normal">
              <div className="col">
                <p
                  className="mb-1"
                  dangerouslySetInnerHTML={{ __html: taskData.text }}
                ></p>
                {taskData.code && (
                  <div>
                    <SyntaxHighlighter
                      language={taskData.codeLanguage}
                      style={okaidia}
                    >
                      {taskData.code}
                    </SyntaxHighlighter>
                  </div>
                )}
                {taskData.optionalText && <div>{taskData.optionalText}</div>}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="accordion m-2" id={"answersTask" + taskData.uuid}>
                {taskData.solutions &&
                  taskData.solutions.map((solution) => (
                    <div key={solution.uuid} className="accordion-item">
                      <h2
                        className="accordion-header"
                        id={
                          "answerHeader" +
                          solution.solutionNumber +
                          "Task" +
                          taskData.uuid
                        }
                      >
                        <button
                          className="accordion-button collapsed pt-2 pb-2"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={
                            "#answerCollapse" +
                            solution.solutionNumber +
                            "Task" +
                            taskData.uuid
                          }
                          aria-expanded="false"
                          aria-controls={
                            "answerCollapse" +
                            solution.solutionNumber +
                            "Task" +
                            taskData.uuid
                          }
                        >
                          {Number(solution.solutionNumber) === 0 ||
                          solution.solutionNumber === ""
                            ? `Відповідь`
                            : `Відповідь. Спосіб ${solution.solutionNumber}`}
                        </button>
                      </h2>
                      <div
                        className="accordion-collapse collapse"
                        id={
                          "answerCollapse" +
                          solution.solutionNumber +
                          "Task" +
                          taskData.uuid
                        }
                        aria-labelledby={
                          "answerHeader" +
                          solution.solutionNumber +
                          "Task" +
                          taskData.uuid
                        }
                      >
                        <div className="accordion-body">
                          {solution.text && (
                            <p
                              style={{ fontWeight: "bold" }}
                              dangerouslySetInnerHTML={{
                                __html: solution.text,
                              }}
                            />
                          )}
                          <SyntaxHighlighter
                            language={solution.codeLanguage}
                            style={okaidia}
                          >
                            {solution.code}
                          </SyntaxHighlighter>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
